export default function HymnsInfo() {
  return (
    <div style={{ padding: 16 }}>
      <h3>About Hymns</h3>
      <p>
        Hymns lets you search your church song library by number or title and
        send selected songs into the Service queue.
      </p>
      <p>
        Imported song files live outside Git and can be mapped into Supabase
        with the local hymn import script.
      </p>
    </div>
  );
}
